import { humanRigs, type HumanFace, type HumanRigId, type HumanSkull } from './human.js';

/** Ancestry proportions over the matching Human head; the chin-to-neck profile stays on the shared anatomy. */
export function humanoidSkull(body: HumanRigId, jawWidth = 1, cheekWidth = 1, underbite = 0): HumanSkull {
  const skull = structuredClone(humanRigs[body].skull);
  skull.jaw.width = skull.jaw.width.map((width, i) => width * (i < 4 ? jawWidth : cheekWidth));
  skull.jaw.front = skull.jaw.front.map((depth, i) => depth + underbite * (i < 4 ? 1 : i === 4 ? .3 : 0));
  return skull;
}

/** Relative facial proportions keep the Human body's own chin, length and nose placement. */
export function humanoidFace(body: HumanRigId, proportions: Partial<HumanFace>, offsets: Partial<HumanFace> = {}): HumanFace {
  const face = { ...humanRigs[body].face };
  for (const [key, value] of Object.entries(proportions)) face[key as keyof HumanFace] *= value;
  for (const [key, value] of Object.entries(offsets)) face[key as keyof HumanFace] += value;
  return face;
}
